import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCategory, getCategoryV5 } from "./api/category";

export const fetchGetCategory = createAsyncThunk("GetCategory", async () => {
  const response = await getCategory();
  return response?.data;
});

export const fetchGetCategoryV5 = createAsyncThunk(
  "GetCategoryV5",
  async (experience: string | null) => {
    const response = await getCategoryV5(experience);
    return response?.data;
  }
);
